import { Component, Injector } from '@angular/core';
import {
  SystemParameterProfileProviders
} from '../../../core/templates/profile-form.template.providers';
import {
  BFOnFormLoadComplete, BFProfileOnSave,
} from '../../../core/interfaces/sdk-profile-hooks.interface';
import { SystemParametersService } from './services/system-parameters.service';
import { SystemParametersCustomReducer } from './system-parameters-custom.reducer';
import { AbstractProfileFormComponent } from "../../abstract/abstract-profile/abstract-profile-form.component";
import { SystemParameters } from './models/system-parameters.model';

@Component({
  selector: 'app-systpar-profile',
  templateUrl: '../../../core/templates/profile-form.template.html',
  styleUrls: ['../../../core/templates/profile-form.template.scss'],
  providers: SystemParameterProfileProviders
})
export class SystemParametersComponent extends AbstractProfileFormComponent implements BFOnFormLoadComplete, BFProfileOnSave {

  private static readonly WEBIDLTME = 'WEBIDLTME';
  private static readonly minWEBIDLTME = 60;

  constructor(protected injector: Injector,
              private systemParametersService: SystemParametersService,
  ) {
    super(injector);
  }

  fgppFormLoadComplete(): void {
    this.systemParametersService.hideFields();
    this.systemParametersService.showRelevantValueField();
  }

  fgppOnSave(): boolean {
    if (!this.validateWebIdleTime()) {
      return false
    }
    this.systemParametersService.convertFieldsValueToString();
    return true;
  }

  fgppOnInit(): void {
    this.setCustomReducer(new SystemParametersCustomReducer());
  }

  private validateWebIdleTime(): boolean {
    if (this.formMgr.get(SystemParameters.PARAM_NAME).getValue() === SystemParametersComponent.WEBIDLTME) {
      const value = this.formMgr.get(this.systemParametersService.virtualValueField).getValue();
      if (Number(value) < SystemParametersComponent.minWEBIDLTME) {
        this.notificationService.error(this.translate.instant('business-framework.profiles.54.errors.min-web-idle-time', { min: SystemParametersComponent.minWEBIDLTME }));
        return false;
      }
    }
    return true;
  }
}
